module.exports = __webpack_public_path__ + "img/charging-session-infograph-desktop.380f7792.webp";